

const testimonials = [
    {
      text: "A big heartfelt and grateful shoutout to Akhilesh Sir for teaching core finance courses...",
      name: "MADHURA JUGDAR",
      role: "FP&A ANALYST, QUALYS PUNE",
      companyLogo: "/assets/icons/qualys.png",
      linkedInIcon: "/assets/icons/linkedicon.png",

      image: "/assets/icons/profile.jpg",
    },
    {
      text: "A big heartfelt and grateful shoutout to Akhilesh Sir for teaching core finance courses...",
      name: "RAHUL SHARMA",
      role: "FINANCIAL ANALYST, TCS",
      companyLogo: "/assets/icons/qualys.png", // Replace with actual URL
      linkedInIcon: "/assets/icons/linkedicon.png",

      image: "/assets/icons/profile.jpg",
    },
    {
      text: "A big heartfelt and grateful shoutout to Akhilesh Sir for teaching core finance courses...",
      name: "PRIYA VERMA",
      role: "INVESTMENT BANKER, JP MORGAN",
      companyLogo: "/assets/icons/qualys.png", // Replace with actual URL
      linkedInIcon: "/assets/icons/linkedicon.png",

      image: "/assets/icons/profile.jpg",
    },
    {
      text: "A big heartfelt and grateful shoutout to Akhilesh Sir for teaching core finance courses...",
      name: "TUSHAR GODSE",
      role: "INVESTMENT BANKER, JP MORGAN",
      companyLogo: "/assets/icons/qualys.png", // Replace with actual URL
      linkedInIcon: "/assets/icons/linkedicon.png",

      image: "/assets/icons/profile.jpg",
    },
    {
      text: "A big heartfelt and grateful shoutout to Akhilesh Sir for teaching core finance courses...",
      name: "SHRAVASTI LOKHANDE",
      role: "INVESTMENT BANKER, JP MORGAN",
      companyLogo: "/assets/icons/qualys.png", // Replace with actual URL
      linkedInIcon: "/assets/icons/linkedicon.png",

      image: "/assets/icons/profile.jpg",
    },
    {
      text: "A big heartfelt and grateful shoutout to Akhilesh Sir for teaching core finance courses...",
      name: "ADITYA BAGGADE",
      role: "INVESTMENT BANKER, JP MORGAN",
      companyLogo: "/assets/icons/qualys.png", // Replace with actual URL
      linkedInIcon: "/assets/icons/linkedicon.png",

      image: "/assets/icons/profile.jpg",
    },
  ];
  
  export default testimonials;
  